import Util from '../../lib/utils';
import Vue from 'vue';
import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Marketingstaff from '../entities/marketingstaff';
import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import Vuex from 'vuex';
Vue.use(Vuex);

interface MarketingstaffState extends ListState<Marketingstaff> {
    editMarketingstaff: Marketingstaff;
    total: '';
    shopid: '';
    registerInfoLoading: boolean;
    clerkno: string;
}
class MarketingstaffModule extends ListModule<MarketingstaffState, any, Marketingstaff> {
    public state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<Marketingstaff>(),
        loading: false,
        registerInfoLoading: false,
        clerkno: ''
    };
    public actions = {
        async getSalemanLookItemEvaluate(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetSalemanLookItemEvaluate', { params: payload.data });
            return reponse.data.result;
        },
        async getSalemanLookSerEvaluate(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetSalemanLookSerEvaluate', { params: payload.data });
            return reponse.data.result;
        },
        async saleManGoalTask(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/SaleManGoalTask', { params: payload.data });
            return reponse.data.result;
        },
        async saleManTalkTask(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/SaleManTalkTask', { params: payload.data });
            return reponse.data.result;
        },
        async vipInfoTaskList(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/VipInfoTaskList', { params: payload.data });
            return reponse.data.result;
        },
        async getTakeToForm(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetTakeToForm', { params: payload.data });
            return reponse.data.result;
        },
        async salemanExecuteTask(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.post('/api/services/app/OfflineSaleClerk/SalemanExecuteTask', payload.data);
            return reponse.data.result;
        },
        async getRegisterGiftInfo(context: ActionContext<MarketingstaffState, any>, payload: any) {
            const reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetRegisterGiftInfo', payload.data);
            context.state.registerInfoLoading = true;
            return reponse.data.result;
        },
        async createClerkQrcode(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/CodeManagementService/CreateQrCode', payload.data);
            return reponse.data.result;
        },
        async getClerkno(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetClerkno');
            if (reponse.data.result.code == 1) {
                context.state.clerkno = reponse.data.result.data.clerkno;
            }
            return reponse.data.result;
        },
        async bindSaleClerk(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/OfflineSaleClerk/BindSaleClerk?clerkno=' + payload.data.clerkno);
            return reponse.data.result;
        },
        async registerByCode(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/OfflineSaleClerk/RegisterByCode?phone=' + payload.data.phone);
            return reponse.data.result;
        },
        async activateCard(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/OfflineSaleClerk/ActivateCard', payload.data);
            return reponse.data.result;
        },
        async getMemberVisitEditType(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/GetMemberVisitEditType', payload.data);
            return reponse.data.result;
        },
        async writeMemberVisit(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.post('/api/services/app/OfflineSaleClerk/WriteMemberVisit', payload.data);
            return reponse.data.result;
        },
        async wxBindClerk(context: ActionContext<MarketingstaffState, any>, payload: any) {
            await Ajax.post('/api/services/app/OfflineSaleClerk/WxBindClerk?id=' + payload.data.id);
        },
        /**
         * 获取商户是否授权公众号
         * @param context 
         * @param payload 
         */
        async getWxghAuthorizeStatus(context: ActionContext<MarketingstaffState, any>, payload: any) {
            let reponse = await Ajax.get('/api/services/app/OfflineSaleClerk/getWxghAuthorizeStatus', payload.data);
            return reponse.data.result;
        },
        /**
         * 
         * @param context 获取商户的场景二维码
         * @param payload 
         */
        async getWxghSceneQrCode(context: ActionContext<MarketingstaffState, any>, payload: any) {  
            let reponse = await Ajax.get('/api/services/app/WxGhService/GetQrCode?scene='+payload.data.scene);
            return reponse.data.result;
        },
    };
    public mutations = {
        setCurrentPage(state: MarketingstaffState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: MarketingstaffState, pagesize: number) {
            state.pageSize = pagesize;
        },
        // tslint:disable-next-line:no-shadowed-variable
        edit(state: MarketingstaffState, Marketingstaff: Marketingstaff) {
            state.editMarketingstaff = Marketingstaff;
        },

    };
}
const marketingstaffModule = new MarketingstaffModule();
export default marketingstaffModule;
